import { createI18n } from 'vue-i18n'
import config from './config'
import ar from './locales/ar'
import da from './locales/da'
import de from './locales/de'
import en from './locales/en'
import es from './locales/es'
import fi from './locales/fi'
import fr from './locales/fr'
import hr from './locales/hr'
import it from './locales/it'
import nl from './locales/nl'
import no from './locales/no'
import pl from './locales/pl'
import so from './locales/so'
import sr from './locales/sr'
import sv from './locales/sv'
import zh from './locales/zh-CN'

// TODO: this should use the defaultLanguage for the selected config
function locale() {
  return (
    window.localStorage.getItem('selectedLocale') ||
    config.defaultLanguage ||
    'en'
  )
}

export default new createI18n({
  // locale: process.env.VUE_APP_I18N_LOCALE || locale(),
  // fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'en',
  locale: locale(),
  fallbackLocale: 'en',
  messages: { ar, da, de, en, es, fi, fr, hr, it, nl, no, pl, so, sr, sv, zh }
})
